<div class="modal fade" id="dialogRelatorioLances" tabindex="-1" role="dialog" 
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="bg-primary modal-header text-white">
        Mapa de Lances - {{licitacao.numero | LICITACAO}}
      </div>
      <div class="modal-body pt-0">
        <p-fieldset legend="Opções do Relatório">
        </p-fieldset>
        <p-fieldset legend="Formatos">
          <p-radioButton name="formatoGroup" [value]="format" [label]="format" class="mr-2 mt-2" [(ngModel)]="formato"
            *ngFor="let format of listFormato">
          </p-radioButton>
        </p-fieldset>
        <p-fieldset legend="Opções do PDF" *ngIf="formato === 'pdf'">
          <p-radioButton name="formatoGroup" [value]="orient.id" [label]="orient.nome" class="mr-2 mt-2"
            [(ngModel)]="orientacao" *ngFor="let orient of listOrientacao">
          </p-radioButton>
        </p-fieldset>
      </div>
      <div class="modal-footer">
        <button (click)="imprimir()" type="button" data-dismiss="modal" class="btn btn-primary btn-sm">
          Gerar Relatório
        </button>
        <button type="button" class="btn btn-link btn-sm" data-dismiss="modal">Cancelar</button>
      </div>
    </div>
  </div>
</div>